import * as Telecom from '@servicetitan/telecom-rtcs-client';
import getQueue from '../../lib/getQueue';
import log from '../../lib/log';
import { refreshQueueOnCacheMiss } from '../../lib/refreshQueue';
import { discardStaleQueueStatus } from '../../lib/coalesceWorkspaceEvents';

async function handleQueueAgentAdded(event: Telecom.QueueAgentAddedEvent) {
  discardStaleQueueStatus(event.queueId);
  const queue = getQueue(event.queueId);

  log('rtcs:queue:agent_added:' + queue?.name, event);

  if (!queue) {
    await refreshQueueOnCacheMiss(event.queueId);
    return;
  }

  queue.memberIds = [...queue.memberIds, event.agentId];
}

export default handleQueueAgentAdded;
